import { useEffect, useState } from "react";
import { PHOTO_BOX, VIEW } from "../../lib/shield";

const S = 1.5;
const imgs = new Map();
const loadImg = (src) => {
  if (!imgs.has(src)) imgs.set(src, new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = src; }));
  return imgs.get(src);
};

const fadeMask = (ctx, x0, y0, x1, y1, stops) => {
  const g = ctx.createLinearGradient(x0 * S, y0 * S, x1 * S, y1 * S);
  stops.forEach(([o, a]) => g.addColorStop(o, `rgba(0,0,0,${a})`));
  ctx.globalCompositeOperation = "destination-in";
  ctx.fillStyle = g;
  ctx.fillRect(0, 0, VIEW.w * S, VIEW.h * S);
};

function bake(img, { file, crop, zoom = 1, x = 0, y = 0 }, box, row) {
  const fx = img.naturalWidth / file.w, fy = img.naturalHeight / file.h;
  const cx = crop ? (crop.x / 100) * file.w : 0, cy = crop ? (crop.y / 100) * file.h : 0;
  const cw = crop ? (crop.width / 100) * file.w : file.w, ch = crop ? (crop.height / 100) * file.h : file.h;
  const s = Math.max(box.w / cw, box.h / ch) * zoom;
  const dw = cw * s, dh = ch * s;
  const c = document.createElement("canvas");
  c.width = VIEW.w * S; c.height = VIEW.h * S;
  const ctx = c.getContext("2d");
  ctx.drawImage(img, cx * fx, cy * fy, cw * fx, ch * fy, (box.x + (box.w - dw) / 2 + x) * S, (box.y + (box.h - dh) / 2 + y) * S, dw * S, dh * S);
  fadeMask(ctx, 0, PHOTO_BOX.y + PHOTO_BOX.h * 0.62, 0, PHOTO_BOX.y + PHOTO_BOX.h, [[0, 1], [1, 0]]);
  fadeMask(ctx, PHOTO_BOX.x, 0, row ? PHOTO_BOX.x + PHOTO_BOX.w : PHOTO_BOX.x + 56, 0, row ? [[0, 0], [0.2, 1], [0.8, 1], [1, 0]] : [[0, 0], [1, 1]]);
  return new Promise((res) => c.toBlob((b) => res(b && URL.createObjectURL(b)), "image/png"));
}

// Phone browsers can drop masked photos entirely, so on screen the fade is painted into a plain image instead.
export const FadedPhoto = ({ photo, href, box, row }) => {
  const [url, setUrl] = useState(null);
  const { file, crop, zoom, x, y } = photo;
  useEffect(() => {
    if (!href || !file) return undefined;
    let live = true;
    const frame = requestAnimationFrame(() => {
      loadImg(href).then((img) => bake(img, { file, crop, zoom, x, y }, box, row)).then((u) => {
        if (!live) return u && URL.revokeObjectURL(u);
        setUrl((old) => { if (old) setTimeout(() => URL.revokeObjectURL(old), 1000); return u; });
      }).catch(() => {});
    });
    return () => { live = false; cancelAnimationFrame(frame); };
  }, [href, file, crop, zoom, x, y, box, row]);
  useEffect(() => () => url && setTimeout(() => URL.revokeObjectURL(url), 1000), [url]);
  return url ? <image href={url} width={VIEW.w} height={VIEW.h} preserveAspectRatio="none" data-testid="faded-photo" /> : null;
};
